import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '.';

const DEFAULT_IMG = 'https://assets.funliday.com/users/img_avatar_default.png';

const LazyMemberImg = ({ alt, src, title, className, style, onClick }) => {
  // props.src 若有 user 圖片連結但 404 就要 fallback 回 DEFAULT_IMG) 不要相信使用者上傳的圖片是否有效
  const onMemberImgError = e => {
    e.target.onerror = null;
    e.target.src = DEFAULT_IMG;
  };

  return (
    <LazyImg
      src={src}
      alt={alt}
      title={title}
      className={className}
      style={style}
      onError={onMemberImgError}
      defaultImg={DEFAULT_IMG}
      onClick={onClick}
    />
  );
};

LazyMemberImg.defaultProps = {
  alt: 'member-img',
  title: 'member-title',
  src: DEFAULT_IMG,
  className: '',
  style: {},
  onClick: null,
};

LazyMemberImg.propTypes = {
  alt: PropTypes.string,
  title: PropTypes.string,
  src: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default LazyMemberImg;
